import { queryClient } from '@/query/queryClient'
import { workspacesQueryKey } from '@/hooks/useWorkspaces'
import { backendProjectsQueryKey } from '@/components/AppShell/useBackendProjects'
import { documentsQueryKey } from '@/features/chat/documents/useDocuments'
import { workflowsQueryKey } from '@/features/chat/workflows/useWorkflows'
import { connectionsQueryKey } from '@/features/integrations/useConnections'
import { getActiveWorkspaceId } from '@/store/workspaceStore'
import { invalidateConversationSearch } from '@/services/chat/invalidateConversationSearch'

export function workspaceScopedKey(baseKey) {
  const workspaceId = getActiveWorkspaceId()
  return workspaceId ? [...baseKey, workspaceId] : baseKey
}

export function appendWorkspaceCache(client, workspace) {
  client.setQueryData(workspacesQueryKey, (prev) => {
    const existing = Array.isArray(prev?.workspaces) ? prev.workspaces : []
    const workspaces = existing.some((row) => row.id === workspace.id)
      ? existing.map((row) => (row.id === workspace.id ? workspace : row))
      : [...existing, workspace]
    return { workspaces }
  })
}

export function invalidateWorkspaceScopedQueries(workspaceId) {
  queryClient.invalidateQueries({ queryKey: workspacesQueryKey })
  if (!workspaceId) return
  queryClient.invalidateQueries({ queryKey: backendProjectsQueryKey() })
  queryClient.invalidateQueries({ queryKey: documentsQueryKey() })
  queryClient.invalidateQueries({ queryKey: workflowsQueryKey() })
  queryClient.invalidateQueries({ queryKey: connectionsQueryKey() })
  invalidateConversationSearch()
}
